// src/features/clinical/pages/NewVisitPage.jsx
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PatientSearch from '../components/patient/PatientSearch';
import VisitCreation from '../components/visit/VisitCreation';

const NewVisitPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedPatient, setSelectedPatient] = useState(null);
  const patientId = searchParams.get('patientId');

  React.useEffect(() => {
    if (patientId && !selectedPatient) {
      // Load patient details
      // You can add API call here
    }
  }, [patientId]);

  const handleVisitCreated = (visit) => {
    navigate(`/clinical/visits/${visit.id}/vitals`);
  };

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">New Patient Visit</h1>
      
      {!selectedPatient ? (
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Select Patient</h2>
          <PatientSearch onSelectPatient={setSelectedPatient} />
        </div>
      ) : (
        <VisitCreation
          patientId={selectedPatient.id}
          patientName={selectedPatient.name}
          onVisitCreated={handleVisitCreated}
        />
      )}
    </div>
  );
};

export default NewVisitPage;